module.exports = __webpack_public_path__ + "static/img/exhibitFormTips9.27179c4e.png";